import styled  from '@themes/theme'
import { keyframes } from '@emotion/core'

const RewardImgTopAni = keyframes`
  0% {
    transform: translate3d(-50%, -40%, 0);
  }
  30% {
    transform: translate3d(-50%, -40%, 0);
  }
  40%, 45% {
    transform: translate3d(-50%, -40%, 0) scale(114%, 77%);
    opacity: 1;
  }
  60% {
    transform: translate3d(-50%, -80%, 0) scale(96%, 110%);
    opacity: 0;
  }
  65% {
    transform: translate3d(-50%, -150%, 0) scale(100%, 100%);
    opacity: 0;
  }
  100% {
    transform: translate3d(-50%, -150%, 0) scale(100%, 100%);
    opacity: 0;
  }
`
const RewardImgCenterAni = keyframes`
  0%, 30% {
    transform: translate3d(-50%, -50%, 0) scale(0);
  }
  40%, 45% {
    transform: translate3d(-50%, -50%, 0) scale(0.8);
  }
  60% {
    transform: translate3d(-50%, -80%, 0) scale(1);
    animation-timing-function: cubic-bezier(0,.49,.64,.99);
  }
  //65% {
  //  transform: translate3d(-50%, -80%, 0) scale(1);
  //}
  90%, 100% {
    transform: translate3d(-50%, -73%, 0) scale(1);
  }
`
const RewardImgEffectAni = keyframes`
  0%, 30% {
    opacity: 0;
  }
  40%, 45% {
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  90%, 100%  {
    opacity: 1;
  }
`
const RewardImgBottomAni = keyframes`
  0%, 30% {
    transform: translate3d(-50%, -34%, 0) scale(100%, 100%);  
  }
  40%, 45% {
    transform: translate3d(-50%, -34%, 0) scale(114%, 77%);
  }
  60% {
    transform: translate3d(-50%, -34%, 0) scale(96%, 110%);
    animation-timing-function: cubic-bezier(0,.49,.64,.99);
  }
  90%, 100% {
    transform: translate3d(-50%, -34%, 0) scale(100%, 100%);
  }
`
const AniSec = '1.5s'

export const RewardWrap = styled.div`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  .reward-img {
    position: relative;
    width: 200px;
    height: 140px;
    //overflow: hidden;
    margin: 0 auto;
    .gift-box-img {
      position: absolute;
      height: auto;
      left: 50%;
      &.top {
        width: 95px;
        top: 50%;
        transform: translate3d(-50%, -40%, 0);
        animation: ${RewardImgTopAni} ${AniSec} 1 ease-in-out forwards;
        transform-origin: bottom;
      }
      &.center {
        width: 95px;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        animation: ${RewardImgCenterAni} ${AniSec} 1 ease-in-out forwards;
        transform-origin: bottom;
      }
      &.back {
        width: 95px;
        top: 50%;
        transform: translate3d(-50%, -34%, 0);
        animation: ${RewardImgBottomAni} ${AniSec} 1 ease-in-out forwards;
        transform-origin: bottom;
      }
      &.bottom {
        width: 95px;
        top: 50%;
        transform: translate3d(-50%, -34%, 0);
        animation: ${RewardImgBottomAni} ${AniSec} 1 ease-in-out forwards;
        transform-origin: bottom;
      }
      &.effect {
        width: 260px;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        animation: ${RewardImgEffectAni} ${AniSec} 1 ease-in-out forwards;
      }
    }
  }
  .reward-img-comment-wrap{
    .gift-box-img {
      &.comment{
        width: 262px;
        margin-top: 25px;
      }
    }
  }
`
